import type { FormValues } from "@/widgets/classic-form/form";
import { FieldComposer, fieldToConfig } from "@/features/form-fields";
import { type EventAssertion, type Field } from "@/entities/form-metadata";
import type { PrefixObjectAccessor } from "@/shared/forms";

interface EventGroupPlaceInputProps {
    fieldData: Field<EventAssertion>;
    fieldPath: string;
    inputProperties?: React.InputHTMLAttributes<HTMLInputElement>;
}

export const EventGroupPlaceInput: React.FC<EventGroupPlaceInputProps> = ({
    fieldData,
    fieldPath,
    inputProperties,
}) => {
    const exactnessFieldPath = `${fieldPath}.locationExactness` as PrefixObjectAccessor<FormValues, []>;
    return (
        <FieldComposer
            fieldPath={fieldPath}
            exactnessFieldPath={exactnessFieldPath}
            fieldConfig={fieldToConfig(fieldData)}
        >
            <FieldComposer.GenericField {...inputProperties} />
            <FieldComposer.GenericExactness />
        </FieldComposer>
    );
};
